(function() {
  let lastHasSubscription = null;
  let drawerInitialized = false;
  let checkInterval = null;

  // Wait until drawer content is ready with timeout
  function waitForDrawerContent(callback, timeout = 3000) {
    const startTime = Date.now();
    const interval = setInterval(() => {
      const drawer = document.querySelector('.drawer--cart');
      if (!drawer || window.getComputedStyle(drawer).display === 'none') {
        clearInterval(interval);
        return;
      }

      const footer = drawer.querySelector('.ajaxcart__footer');
      const items = drawer.querySelectorAll('.ajaxcart__product');
      const checkoutBtns = drawer.querySelectorAll('.cart__checkout');
      
      if (footer && checkoutBtns.length) {
        clearInterval(interval);
        callback(drawer);
      } else if (Date.now() - startTime > timeout) {
        clearInterval(interval);
        console.warn('Drawer content timeout');
      }
    }, 100);
  }

  // Add the consent checkbox
  function prependConsent(drawer) {
    const footer = drawer.querySelector('.ajaxcart__footer');
    if (!footer) return;
    
    // Remove existing container if present
    const existing = footer.querySelector('#effectiveAppsAgreeContainer');
    if (existing) {
      existing.remove();
    }

    const container = document.createElement('div');
    container.id = 'effectiveAppsAgreeContainer';
    container.style = 'margin-top:15px; display:none;';
    container.innerHTML = `
      <p>
        <input type="checkbox" id="effectiveAppsAgreeCB" style="-webkit-appearance:checkbox; float:none; vertical-align:middle;">
        &nbsp;
        <label for="effectiveAppsAgreeCB" style="display:inline; float:none;">
          <span style="color:rgba(0,0,0,.56); font-size:14px;">
            One or more items in your cart is a recurring purchase. By continuing with your payment, you agree that your payment method will automatically be charged at the price and frequency listed on this page until you cancel. All cancellations are subject to the 
            <a href="javascript:TAC_openPopup('https://www.lemonandco.com/pages/cancelation-policy');" style="text-decoration:underline;">cancellation policy</a>.
          </span>
        </label>
      </p>
    `;
    footer.prepend(container);
  }

  // Check if cart has any subscription product
  async function checkCartSubscription() {
    try {
      const res = await fetch('/cart.js', { credentials: 'include' });
      const cart = await res.json();
      const subscriptionInCart = cart.items.some(item => item.selling_plan_allocation);
      const subscriptionSelected = Array.from(document.querySelectorAll('.subscribe_button_cart')).some(select => select.value);
      const hasSubscription = subscriptionInCart || subscriptionSelected;

      if (hasSubscription !== lastHasSubscription) {
        lastHasSubscription = hasSubscription;
        const container = document.querySelector('#effectiveAppsAgreeContainer');
        if (container) container.style.display = hasSubscription ? 'block' : 'none';
        if (!hasSubscription) {
          const checkbox = document.getElementById('effectiveAppsAgreeCB');
          if (checkbox) checkbox.checked = false;
        }
      }
    } catch (e) {
      console.warn('Cart fetch failed', e);
    }
  }

  // Protect checkout buttons
  function protectCheckoutButtons(drawer) {
    drawer.querySelectorAll('.cart__checkout').forEach(btn => {
      // Remove existing override
      if (btn.dataset.overrideApplied === 'true') {
        btn.dataset.overrideApplied = 'false';
      }
      
      const clean = btn.cloneNode(true);
      clean.dataset.overrideApplied = 'true';
      btn.parentNode.replaceChild(clean, btn);

      clean.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        const checkbox = document.getElementById('effectiveAppsAgreeCB');
        if (lastHasSubscription && (!checkbox || !checkbox.checked)) {
          alert('Please confirm the subscription terms before continuing to checkout.');
          return;
        }
        window.location.href = '/checkout';
      });
    });
  }

  // Delayed check with multiple attempts
  function delayedCheckCart() {
    // Check multiple times to catch AJAX cart updates
    setTimeout(checkCartSubscription, 300);
    setTimeout(checkCartSubscription, 600);
    setTimeout(checkCartSubscription, 1000);
  }

  // Bind events to dynamic elements inside the drawer (use event delegation)
  function bindDrawerEvents(drawer) {
    // Remove existing event listeners by cloning
    if (drawer.dataset.eventsAttached === 'true') {
      return;
    }
    drawer.dataset.eventsAttached = 'true';

    // Subscription select change
    drawer.addEventListener('change', e => {
      if (e.target.matches('.subscribe_button_cart')) delayedCheckCart();
    });
    
    // Quantity input - watch for changes
    drawer.addEventListener('input', e => {
      if (e.target.matches('.ajaxcart__qty-num')) delayedCheckCart();
    });
    
    // Quantity change (for when input loses focus)
    drawer.addEventListener('change', e => {
      if (e.target.matches('.ajaxcart__qty-num')) delayedCheckCart();
    });
    
    // Remove buttons
    drawer.addEventListener('click', e => {
      if (e.target.matches('.ajaxcart__qty-remove')) delayedCheckCart();
    });

    // Watch for cart item removals via DOM changes
    const drawerObserver = new MutationObserver(() => {
      delayedCheckCart();
    });
    drawerObserver.observe(drawer, { 
      childList: true, 
      subtree: true 
    });

    // Store observer for cleanup
    drawer._cartObserver = drawerObserver;
  }

  // Reset drawer state
  function resetDrawer() {
    drawerInitialized = false;
    lastHasSubscription = null;
    const drawer = document.querySelector('.drawer--cart');
    if (drawer) {
      drawer.dataset.eventsAttached = 'false';
      // Disconnect observer if exists
      if (drawer._cartObserver) {
        drawer._cartObserver.disconnect();
        drawer._cartObserver = null;
      }
    }
  }

  // Check if drawer is visible
  function isDrawerVisible() {
    const drawer = document.querySelector('.drawer--cart');
    if (!drawer) return false;
    const style = window.getComputedStyle(drawer);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  // Initialize drawer every time it opens
  function initDrawer() {
    if (drawerInitialized) return;
    
    const drawer = document.querySelector('.drawer--cart');
    if (!drawer || !isDrawerVisible()) return;

    drawerInitialized = true;
    
    waitForDrawerContent(drawer => {
      prependConsent(drawer);
      protectCheckoutButtons(drawer);
      bindDrawerEvents(drawer);
      checkCartSubscription();
    });
  }

  // Watch for drawer visibility changes
  let lastDrawerVisible = false;
  function checkDrawerVisibility() {
    const visible = isDrawerVisible();
    if (visible !== lastDrawerVisible) {
      lastDrawerVisible = visible;
      if (visible) {
        initDrawer();
      } else {
        resetDrawer();
      }
    }
  }

  // Observe body for drawer changes
  const observer = new MutationObserver(() => {
    checkDrawerVisibility();
  });
  observer.observe(document.body, { 
    childList: true, 
    subtree: true, 
    attributes: true, 
    attributeFilter: ['style', 'class'] 
  });

  // Poll for drawer visibility as backup
  setInterval(checkDrawerVisibility, 200);

  // Also run on first page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkDrawerVisibility);
  } else {
    checkDrawerVisibility();
  }

})();



function TAC_openPopup(url) {
    var w = 600;
    var h = 850;
    var left = (screen.width/2)-(w/2);
    var top = (screen.height/2)-(h/2);
    return window.open(url, "", 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
}